
import fetch from "cross-fetch";
import {refreshTokens} from './iam/operations';
import {isAccessTokenEpired} from './iam/selectors';

let refreshing_token = undefined;

function fetchRetry(url, options={}, dispatch, getState){
    return new Promise(function(resolve, reject) {
        fetch(url, options).then(function(response) {
            if(response.status === 401){
                 
                if(isAccessTokenEpired(getState())){
                    if(!refreshing_token){
                        refreshing_token = dispatch(refreshTokens()) 
                    }    

                    refreshing_token.then(refreshing_response=>{
                        refreshing_token = undefined;                         
                        options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`  
                        fetchRetry(url, options, dispatch, getState)
                            .then(resolve)
                            .catch(function(error) {
                                refreshing_token = undefined;
                            });
                    }).catch(function(error) {
                        refreshing_token = undefined;
                    });
                }else{
                    resolve(response);
                }                                    
            }else{
                resolve(response);
            }               
        })  
            // .catch(function(error) {
            //     console.log('error: ', error);

            //     return reject(error); // <--- base case!
            //     // fetchRetry(url, options, dispatch, getState)
            //     //     .then(resolve)
            //     //     .catch(reject);
            // })
    });
}

export default fetchRetry;